import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import { PreferencesListPage } from 'syft-acp-core/components/ClientPreferences'
import SiteComponent from 'syft-acp-core/components/SiteComponent'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'

type RouteParams = {
  id?: string
}

const EmployerPreferencesView = (props: RouteComponentProps<RouteParams>) => {
  const employerID = props.match.params?.id
  const employerName = useEmployerName(Number(employerID))

  return (
    <PageTitle title={['Fulfilment preferences', recordLabel('Employer', employerID, employerName)]}>
      <div>
        <SubNavigation subPage="employers" data={{ employerID: Number(props.match.params?.id) }} />
        <SiteComponent>
          <PreferencesListPage
            title="Fulfilment preferences — head office"
            employerID={Number(props.match.params?.id)}
          />
        </SiteComponent>
      </div>
    </PageTitle>
  )
}

export default EmployerPreferencesView
